import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectorRef,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FilterConfig, FiltersCardConfig } from '@proxy/filters/models';

@Component({
  selector: 'app-filters-card',
  templateUrl: './filters-card.component.html',
  styleUrls: ['./filters-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FiltersCardComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() config: FiltersCardConfig;

  @Input() filterValues: Record<string, any> = {};
  @Output() filterValuesChange = new EventEmitter<Record<string, any>>();

  @Output() apply = new EventEmitter<void>();

  @Output() clearAll = new EventEmitter<void>();

  isCollapsed = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.isCollapsed = this.config?.startCollapsed ?? false;
    this.ensureDateFilterDefaults();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config || changes.filterValues) {
      this.ensureDateFilterDefaults();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cdRef.detectChanges();
    });
  }

  /**
   * datetime-picker does not render its inner template when the bound value is `undefined`.
   * Ensure all date filters have at least `null` as their initial value.
   */
  private ensureDateFilterDefaults(): void {
    if (!this.config?.filters || !this.filterValues) return;

    for (const filter of this.config.filters) {
      if ((filter.type === 'date' || filter.type === 'date-range') && this.filterValues[filter.key] === undefined) {
        this.filterValues[filter.key] = null;
      }
    }
  }

  toggle(): void {
    this.isCollapsed = !this.isCollapsed;
    setTimeout(() => {
      this.cdRef.detectChanges();
    }, 150);
  }

  onApply(): void {
    this.apply.emit();
  }

  onClearAll(): void {
    this.clearAll.emit();
  }

  onFilterChange(filter: FilterConfig, value: any): void {
    this.filterValues[filter.key] = value;
    this.filterValuesChange.emit(this.filterValues);
    filter.onChange?.(value);
  }

  getEmptyValue(filter: FilterConfig): any {
    return filter.emptyValue !== undefined ? filter.emptyValue : null;
  }

  trackByKey(_index: number, item: any): any {
    return item.key ?? item.value;
  }

  trackByFilterKey(_index: number, filter: FilterConfig): string {
    return filter.key;
  }
}
